export const AI_TASKS = {
    embed: {
        description: "Embed text for semantic search",
        capabilities: ["embedding"],
        expectedDimensions: 1024,
        defaults: {
            anthropic: null,
            openai: {
                model: "text-embedding-3-large",
                params: { dimensions: 1024 },
            },
            google: { model: "text-embedding-004" },
        },
    },
    bug_coverage: {
        description: "Decide if a bug scenario is covered by existing tests",
        capabilities: ["structured_output"],
        defaults: {
            anthropic: { model: "claude-sonnet-4-5" },
            openai: { model: "gpt-4o" },
            google: { model: "gemini-2.0-flash" },
        },
    },
    qa_chat: {
        description: "Answer questions about specs and implementation",
        capabilities: ["streaming", "long_context"],
        defaults: {
            anthropic: { model: "claude-sonnet-4-5" },
            openai: { model: "gpt-4o" },
            google: { model: "gemini-2.0-flash" },
        },
    },
    semantic_link: {
        description: "Decide if a commit implements a candidate ticket",
        capabilities: ["structured_output", "fast"],
        defaults: {
            anthropic: { model: "claude-haiku-4-5" },
            openai: { model: "gpt-4o-mini" },
            google: { model: "gemini-2.0-flash-lite" },
        },
    },
    repo_spec_gen: {
        description: "Reverse-engineer OpenSpec specs from a code repository (drives spec-gen-cli)",
        capabilities: ["long_context", "structured_output"],
        defaults: {
            anthropic: { model: "claude-sonnet-4-5" },
            openai: { model: "gpt-4o" },
            google: { model: "gemini-2.0-flash" },
        },
    },
    qa_query_rewrite: {
        description: "Refine a multi-turn user question into a single self-contained search query for vector retrieval",
        capabilities: ["fast"],
        defaults: {
            anthropic: { model: "claude-haiku-4-5" },
            openai: { model: "gpt-4o-mini" },
            google: { model: "gemini-2.0-flash-lite" },
        },
    },
    qa_route: {
        description: "Classify a QA question as graph-shaped (about repo relationships), spec-shaped (about a service's behavior), or hybrid. Drives retrieval and tool gating.",
        capabilities: ["fast", "structured_output"],
        defaults: {
            anthropic: { model: "claude-haiku-4-5" },
            openai: { model: "gpt-4o-mini" },
            google: { model: "gemini-2.0-flash-lite" },
        },
    },
    knowledge_gen: {
        description: "Synthesize a grounded, human-readable knowledge-hub entry for a topic from retrieved code + Jira evidence",
        capabilities: ["long_context", "structured_output"],
        defaults: {
            anthropic: { model: "claude-sonnet-4-5" },
            openai: { model: "gpt-4o" },
            google: { model: "gemini-2.0-flash" },
        },
    },
    knowledge_verify: {
        description: "Verify that each section of a generated knowledge entry traces to a cited source; flag unsupported claims so they don't get published",
        capabilities: ["structured_output"],
        defaults: {
            anthropic: { model: "claude-sonnet-4-5" },
            openai: { model: "gpt-4o" },
            google: { model: "gemini-2.0-flash" },
        },
    },
};
//# sourceMappingURL=ai-tasks.js.map